  <!-- Item qty edit (opened from grid Item Name click) -->
  <div class="item-qty" *ngIf="isItemMode">
    <div class="item-qty__header">
      <div class="item-qty__title">Item Quantities</div>
      <button type="button" class="item-qty__close" (click)="close()" aria-label="Close">×</button>
    </div>

    <div class="item-qty__body" *ngIf="itemEdit">
      <div class="item-qty__hero">
        <img *ngIf="itemImageUrl" class="item-qty__img" [src]="itemImageUrl" [alt]="itemDisplayName" width="150"
          height="150" />
        <div class="item-qty__meta">
          <div class="item-qty__name">{{ itemEdit?.itemName || '' }}</div>
          <div class="item-qty__subname" *ngIf="itemEdit?.teluguItemName">{{ itemEdit?.teluguItemName }}</div>
          <div class="item-qty__fusion" *ngIf="itemEdit?.itemFusionId">
            <span class="item-qty__fusion-label">Fusion Id</span>
            <span class="item-qty__fusion-value">{{ itemEdit?.itemFusionId }}</span>
          </div>
        </div>
      </div>

      <div class="item-qty__grid">
        <label class="item-qty__field">
          <span>Breakfast used Quantity</span>
          <input type="number" class="item-qty__input" [(ngModel)]="itemEdit.bfQty" min="0" step="any" />
        </label>
        <label class="item-qty__field">
          <span>Lunch used Quantity</span>
          <input type="number" class="item-qty__input" [(ngModel)]="itemEdit.lunchQty" min="0" step="any" />
        </label>
        <label class="item-qty__field">
          <span>Snacks used Quantity</span>
          <input type="number" class="item-qty__input" [(ngModel)]="itemEdit.snacksQty" min="0" step="any" />
        </label>
        <label class="item-qty__field">
          <span>Dinner used Quantity</span>
          <input type="number" class="item-qty__input" [(ngModel)]="itemEdit.DinnerQty" min="0" step="any" />
        </label>
        <button type="button" class="item-qty__submit item-qty__submit--full" (click)="submitItemQty()">Submit</button>
        <button type="button" class="item-qty__submit item-qty__remove item-qty__submit--full" *ngIf="canRemoveItem"
          (click)="removeItem()">Remove</button>
      </div>
    </div>

    <div class="item-qty__footer">
      <!-- <button type="button" class="item-qty__submit" (click)="submitItemQty()">Submit</button> -->
    </div>
  </div>
  <!-- loader -->
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>